import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FileUploadAwareJsonWriterClass;
function FileUploadAwareJsonWriter() {
  if (FileUploadAwareJsonWriterClass === VOID) {
    class $ {
      constructor(wrappedWriter) {
        this.a4a_1 = wrappedWriter;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.b4a_1 = LinkedHashMap().fc();
      }
      c4a() {
        return this.b4a_1;
      }
      b41() {
        // Inline function 'kotlin.apply' call
        this.a4a_1.b41();
        return this;
      }
      c41() {
        // Inline function 'kotlin.apply' call
        this.a4a_1.c41();
        return this;
      }
      t40() {
        // Inline function 'kotlin.apply' call
        this.a4a_1.t40();
        return this;
      }
      u40() {
        // Inline function 'kotlin.apply' call
        this.a4a_1.u40();
        return this;
      }
      c4d(name) {
        // Inline function 'kotlin.apply' call
        this.a4a_1.c4d(name);
        return this;
      }
      i41(value) {
        // Inline function 'kotlin.apply' call
        this.a4a_1.i41(value);
        return this;
      }
      s41(value) {
        // Inline function 'kotlin.apply' call
        this.a4a_1.s41(value);
        return this;
      }
      n41(value) {
        // Inline function 'kotlin.apply' call
        this.a4a_1.n41(value);
        return this;
      }
      k41(value) {
        // Inline function 'kotlin.apply' call
        this.a4a_1.k41(value);
        return this;
      }
      q41(value) {
        // Inline function 'kotlin.apply' call
        this.a4a_1.q41(value);
        return this;
      }
      e4d(value) {
        // Inline function 'kotlin.apply' call
        this.a4a_1.e4d(value);
        return this;
      }
      x41(value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.b4a_1;
        // Inline function 'kotlin.collections.set' call
        var key = this.a4a_1.s4c();
        tmp0.b5(key, value);
        this.a4a_1.m40();
        return this;
      }
      m40() {
        // Inline function 'kotlin.apply' call
        this.a4a_1.m40();
        return this;
      }
      s4c() {
        return this.a4a_1.s4c();
      }
      m6() {
        this.a4a_1.m6();
      }
    }
    initMetadataForClass($, 'FileUploadAwareJsonWriter');
    FileUploadAwareJsonWriterClass = $;
  }
  return FileUploadAwareJsonWriterClass;
}
//region block: exports
export {
  FileUploadAwareJsonWriter as FileUploadAwareJsonWriter1mx337tg0y9oj,
};
//endregion

//# sourceMappingURL=FileUploadAwareJsonWriter.mjs.map
